import React, { useState, useMemo } from 'react';
import {
    Dialog,
    DialogBackdrop,
    DialogPanel,
    DialogTitle,
    Input
} from '@headlessui/react';
import { AutoSizer, List } from 'react-virtualized';
import { LINK_FOR_NO_IMAGE } from 'helpers/constans';
import CopyWrapper from 'components/Common/CopyWrapper';

export interface Props {
    isOpen?: boolean;
    listToken: any[];
    onClose?: () => void;
    changeToken?: (token: any) => void;
}

function DialogToken({
    isOpen = false,
    listToken = [],
    onClose,
    changeToken
}: Props) {
    const [searchValue, setSearchValue] = useState('');

    const handleClose = () => {
        onClose && onClose();
    };

    const handleChangePool = (token: any) => {
        changeToken && changeToken(token);
    };

    const filteredTokens = useMemo(() => {
        return (listToken || []).filter((token: any) => ((token?.mint).toLowerCase().includes(searchValue.toLowerCase()) || (token?.name).toLowerCase().includes(searchValue.toLowerCase())));
    }, [searchValue, listToken]);

    return (
        <>
            <Dialog open={isOpen} onClose={handleClose} className="fixed z-[90000]">
                <div className="fixed inset-0 z-[90001] flex w-screen items-center justify-center p-4">
                    <DialogPanel
                        className="max-w-lg space-y-4 bg-white"
                        style={{ width: '400px', borderRadius: '10px', overflow: 'hidden' }}
                    >
                        <DialogTitle
                            className="font-bold px-3 py-3"
                            style={{ borderBottom: '1px solid #eaeaea' }}
                        >
                            <div className="flex gap-3 items-center">
                                <Input
                                    name="search"
                                    type="text"
                                    className="form-control w-full px-3 py-2"
                                    id="search"
                                    placeholder="Search tokens or mint address"
                                    value={searchValue}
                                    onChange={(e) => setSearchValue(e.target.value)}
                                />
                                <button
                                    type="button"
                                    className="text-xl text-gray-600 hover:text-black"
                                    onClick={handleClose}
                                >
                                    <i className="ri-close-line align-bottom"></i>
                                </button>
                            </div>
                        </DialogTitle>
                        <div className="mt-0">
                            <AutoSizer disableHeight>
                                {({ width }) => (
                                    <List
                                        height={500}
                                        rowCount={filteredTokens.length}
                                        rowHeight={60}
                                        rowRenderer={({ index, key, style }) => {
                                            const token: any = filteredTokens?.[index] || null;
                                            return (
                                                <div
                                                    key={key}
                                                    style={style}
                                                    className="px-3 py-2 hover:bg-gray-100 cursor-pointer border-b border-gray-200"
                                                    onClick={() => handleChangePool(token)}
                                                >
                                                    <div className="d-flex justify-content-start align-items-start gap-2">
                                                        <div className="text-center m-auto w-[30px]">
                                                            <img
                                                                src={token?.logo || LINK_FOR_NO_IMAGE}
                                                                style={{
                                                                    width: "30px",
                                                                    height: "30px",
                                                                    borderRadius: "15px",
                                                                }}
                                                                className="flex-shrink-0 object-fit-cover m-auto w-[30px] h-[30px] !rounded-full"
                                                                alt="token"
                                                            />
                                                        </div>
                                                        <div className="mb-0 flex-grow-1">
                                                            <div><span className="fs-16">{token?.symbol}</span> <span className="fs-11 text-muted ms-2">{token?.name}</span></div>
                                                            <div className="text-muted fs-12">
                                                                <CopyWrapper
                                                                    isShow={true}
                                                                    contentCopy={token?.mint}
                                                                >
                                                                    {" "}
                                                                    <span>
                                                                        {token?.mint?.slice(0, 8) +
                                                                            "..." +
                                                                            token?.mint?.slice(-6)}
                                                                    </span>
                                                                </CopyWrapper>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        }}
                                        scrollToIndex={0}
                                        width={width}
                                    />
                                )}
                            </AutoSizer>
                        </div>
                    </DialogPanel>
                </div>
                <DialogBackdrop
                    className="fixed inset-0 bg-black/30"
                    style={{ backdropFilter: 'blur(8px)' }}
                />
            </Dialog>
        </>
    );
}

export default React.memo(DialogToken);
